import { Component, Input } from "@angular/core";
import { Router } from "@angular/router";
import moment from "moment";
import { Observable } from "rxjs";

@Component({
  selector: "kpi-showings",
  templateUrl: "./kpi-showings.component.html",
  styleUrls: ["./kpi-showings.component.scss"],
})
export class KpiShowingsComponent {
  @Input() resources$: Observable<any>;

  constructor(private router: Router) {}

  navigateToObject(eaOid: string, event: Event): void {
    event.preventDefault();
    this.router.navigate([
      "/crm",
      {
        outlets: {
          primary: ["showings", eaOid, "potential-buyers"],
          sidebar: null,
          modal: [],
        },
      },
    ]);
  }

  formatDate(startTime: string) {
    return moment(startTime, "YYYYMMDDHHmmss").toDate();
  }
}
